module.exports = __webpack_public_path__ + "static/img/preview-03.ac63b9cf.webp";